export const handleFormatResponse = (response) => {
    const active = [];
    const unactive = [];

    response.data.forEach((element) => {
        const InstantFormListItem = {
            data: [element.fanpage, element.form_name],
            _id: element._id,
            rest: element,
        };

        if (element.is_active) {
            active.push(InstantFormListItem);
        }
        if (!element.is_active) {
            unactive.push(InstantFormListItem);
        }
    });

    return { active, unactive };
}